var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcessorIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 42 52"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#processor-icon_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "processor-icon_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 45.41a.95.95 0 0 1-.665-.27C19.708 44.528 5 30.03 5 19.644c-.02-2.06.379-4.103 1.176-6.01A15.5 15.5 0 0 1 9.64 8.538a15.9 15.9 0 0 1 5.212-3.388C16.803 4.371 18.893 3.98 21 4c2.107-.02 4.197.371 6.147 1.15 1.95.78 3.722 1.931 5.212 3.388a15.5 15.5 0 0 1 3.464 5.096A15.2 15.2 0 0 1 37 19.644C37 30.03 22.292 44.528 21.665 45.14a.95.95 0 0 1-.665.27"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#00BCD4",
  stroke: "#fff",
  strokeWidth: 2.909,
  d: "M21 45.41a.95.95 0 0 1-.665-.27C19.708 44.528 5 30.03 5 19.644c-.02-2.06.379-4.103 1.176-6.01A15.5 15.5 0 0 1 9.64 8.538a15.9 15.9 0 0 1 5.212-3.388C16.803 4.371 18.893 3.98 21 4c2.107-.02 4.197.371 6.147 1.15 1.95.78 3.722 1.931 5.212 3.388a15.5 15.5 0 0 1 3.464 5.096A15.2 15.2 0 0 1 37 19.644C37 30.03 22.292 44.528 21.665 45.14a.95.95 0 0 1-.665.27Z",
  mask: "url(#processor-icon_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M28.058 18.588v8.47H13.94v-8.47l4.94-2.118v1.412l3.53-1.412v2.117zm-3.388-1.06.564-4.587h2.118l.564 4.588zm-4.377 6.706h1.412v-2.823h-1.412zm-2.823 0h1.412v-2.823H17.47zm7.059-2.823h-1.412v2.823h1.412z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "processor-icon_svg__a",
  width: 42,
  height: 51.41,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_39913"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1_39913",
  result: "effect2_dropShadow_1_39913"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 2,
  result: "effect3_dropShadow_1_39913"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_1_39913",
  result: "effect3_dropShadow_1_39913"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_39913",
  result: "shape"
})))));
export { SvgProcessorIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/processor-icon.4d50b1d8.svg";